import { render, staticRenderFns } from "./ReportSales.vue?vue&type=template&id=84b9f67e&scoped=true&"
import script from "./ReportSales.vue?vue&type=script&lang=js&"
export * from "./ReportSales.vue?vue&type=script&lang=js&"
import style0 from "./ReportSales.vue?vue&type=style&index=0&id=84b9f67e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b9f67e",
  null
  
)

export default component.exports